import React, { useContext } from "react";

type DetailsGanttContextType = {
  open?: boolean;
  event?: Sentinel.Timeline.Event;
  onClose?: () => void;
  onOpen?: (event: Sentinel.Timeline.Event) => void;
  onEventUpdate?: (patch: Partial<Sentinel.Timeline.Event>) => void;
};

const DetailsGanttContext = React.createContext<DetailsGanttContextType>({});

export const useDetailsGanttContext = () => useContext(DetailsGanttContext);

export default DetailsGanttContext;
